// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteProfile_content__1hTum","warning":"DeleteProfile_warning__1qSmK","button":"DeleteProfile_button__2DEjr"};